import validate from "/working_dir/Frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import checagem_45login_45global from "/working_dir/Frontend/middleware/checagemLogin.global.ts";
import manifest_45route_45rule from "/working_dir/Frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  checagem_45login_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}